import React, { useEffect, useState } from 'react';
import IntlMessages from '../../../../../../helpers/IntlMessages';
const ItemTotalClicks = ({ itemList }) => {
    const [totalClick, setTotalClick] = useState(0);

    useEffect(() => {
        if (itemList !== undefined && itemList !== null && itemList.length > 0) {
            var count = 0;
            itemList.map(i => {
                count += i.clicks;
            });
            setTotalClick(count);
        }
    }, [itemList]);

    return (
        <div className="iconcards-row row d-flex">
            <div className="mb-4 col-sm-12 col-lg-6 col-xl-6">
                <div className="card">
                    <div className="text-center card-body">
                        <i className="iconsminds-finger-print"></i>
                        <p className="card-text font-weight-semibold mb-0" style={{ lineHeight: "17px" }}>
                            <IntlMessages id="dashboards.compendium-total-digital-clicks" />
                        </p>
                        <p className="lead text-center" style={{ fontSize: "1.2rem" }}
                        >{totalClick}  <IntlMessages id="dashboards.clicks" /></p>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default ItemTotalClicks;